import FolderIcon from '@material-ui/icons/Folder';
import AzureStorageCreate from './AzureStorageCreate';
import AzureStorageEdit from './AzureStorageEdit';
import AzureStorageList from './AzureStorageList';
import AzureStorageShow from './AzureStorageShow';

const pages = {
    list: AzureStorageList,
    create: AzureStorageCreate,
    edit: AzureStorageEdit,
    show: AzureStorageShow,
    icon: FolderIcon,
};

export default pages;